/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import Accordion from "components/molecules/Accordion";
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FormLabel from 'components/atoms/Form/FormLabel';
import ChangeLogModal from "components/molecules/ChangeLogModal";
import IconLabelButton from "components/molecules/IconLabelButton";
import Modal from "components/molecules/Modal";
import DataTable from "components/organismos/DataTable/DataTable";
import React from "react";
import { useApplyingTransferForm } from "../ApplyingTab/hook";
import ApprovedStampDomain from "../domain/approvedStampDomain";
import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import TextTooltip from "components/molecules/TextTooltip";

const StampAccordion: React.FC<{ 
  list: ApprovedStampDomain[];
  reasonOptionList: any;
  reasonId: any;
  setReasonId: any;
}> = ({
  list, reasonOptionList, reasonId, setReasonId
}) => {
  const {
    changeLogData,
    setChangeLogData,
    changeLogModalOpen,
    setChangeLogModalOpen,
    setSelectChangelog,
    fetchChangeLog,
  } = useApplyingTransferForm(list);

  const columns = React.useMemo(
    () => [
      {
        Header: "承認日時",
        accessor: "approvalDate",
      },
      {
        Header: '組織名',
        accessor: 'orgName',
      },
      {
        Header: "申請者",
        accessor: "applicant",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: "申請日時",
        accessor: "applicationDate",
      },
      {
        Header: "対象者",
        accessor: "targetPerson",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: () => "対象日付",
        id: "",
        accessor: "targetDate",
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => (
          <div style={{ textAlign: "center" }}>
            <div>
              <div>{cell.row.original.targetDate}</div>
              <IconLabelButton
                onClick={() => {
                  fetchChangeLog(cell.row.original.modifierApplicationId);
                  setChangeLogModalOpen(true);
                  setSelectChangelog("0");
                }}
                text="更新履歴"
                textAlign="center"
                isIcon={false}
              />
            </div>
          </div>
        ),
      },
      {
        Header: "申請\n種別",
        accessor: "modifiyStatusName",
      },
      {
        Header: "出勤組織",
        accessor: "stampOrgName",
      },
      {
        Header: "開始\n時間", // starttime
        accessor: "stampListStartTime", // .startTime
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "center" }}>
            {cell.row.original.stampListStartTime}
          </div>
        ),
      },
      {
        Header: "終了\n時間", // endtime
        accessor: "stampListEndTime", // .endTime
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "center"}}>
            {cell.row.original.stampListEndTime &&
              cell.row.original.stampListEndTime}
          </div>
        ),
      },
      // {
      //   Header: '業務内容', // business content
      //   accessor: 'stampListBusinessName', // .businessName
      //   Cell: (cell: { row :{ isExpanded: boolean, original: any }}) => (
      //     <div style={{ textAlign: 'left', whiteSpace: 'pre' }}>
      //       {cell.row.original.stampListBusinessName}
      //     </div>
      //   ),
      // },
      {
        Header: "申請理由",
        accessor: "applicationReason",
        Cell: (cell: {row: { isExpanded: boolean; original: any }})=>(
          <TextTooltip text={cell.row.original?.applicationReason} textDis={(
            <div className="ellipsis headline-cell-width-100"
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                width: '100px'
              }}>
                {cell.row.original?.applicationReason}
            </div>
          )} />  
        )
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fetchChangeLog, setChangeLogModalOpen, setSelectChangelog]
  );

  return (
    <div
      css={css`
      table {
        table-layout: auto;
      }
      table th:nth-of-type(1) {
        width: 80px;
      }
      table tbody tr td:nth-of-type(1){
        text-align: center;
      }
      table th:nth-of-type(2) {
        width: 110px;
      }
      table th:nth-of-type(3) {
        width: 120px;
      }
      // table td:nth-of-type(3) {
      //   white-space: pre-line;
      // }
      table th:nth-of-type(4) {
        width: 80px;
      }
      table tbody tr td:nth-of-type(4){
        text-align: center;
      }
      table th:nth-of-type(5) {
        width: 120px;
      }
      // table td:nth-of-type(5) {
      //   white-space: pre-line;
      // }
      table th:nth-of-type(6) {
        width: 80px;
      }
      table th:nth-of-type(7) {
        width: 50px;
        white-space: pre;
          }
      table th:nth-of-type(7) span{
        display:block;
        margin: auto;
      }
      table th:nth-of-type(7) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(8) {
        width: 110px;
      }
      table th:nth-of-type(9) {
        width: 75px;
        white-space: pre;
      }
      table th:nth-of-type(9) span{
        display:block;
        margin: auto;
      }
      table th:nth-of-type(9) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(10) {
        width: 75px;
        white-space: pre;
      }
      table th:nth-of-type(10) span{
        display:block;
        margin: auto;
      }
      table th:nth-of-type(10) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(11) {
        width: 100px;
      }

        .modal-table th:nth-of-type(1) {
          width: 25%;
        }
        .modal-table th:nth-of-type(2) {
          width: 25%;
        }
        .modal-table th:nth-of-type(3) {
          width: 25%;
        }
        .modal-table th:nth-of-type(4) {
          width: 25%;
        }
      `}
    >
      <Accordion
        text={`打刻修正申請 (${list.length}件）`}
        callBack={() => {}}
      >
        <FlexBox customStyle={css({padding: '16px 10px 0'})}>
          <FlexBoxItem marginRight="15px">
            <FormLabel label="申請事由" />
          </FlexBoxItem>
          <FlexBoxItem　 basis="300px">
            <VerticalLabelSelectForm
              label=""
              name="reasonId"
              value={String(reasonId || '')}
              setValue={(v) => {setReasonId(v);}}
              options={reasonOptionList}
          />
          </FlexBoxItem>
        </FlexBox>

        <div style={{ overflowX: "auto", whiteSpace: "nowrap", padding:'0 10px 10px' }}>
          <DataTable
            columns={columns}
            classNameParrant="border-left-right border-bottom"
            className="table-no-border-left-right"
            data={list}
            isGlobalFilter={true}
            minWidth="100%"
            sortBy={[{ id: "approvalDate", desc: true }]}
          />
        </div>
      </Accordion>

      {/* Change log  */}
      <div css={css(">div>div{ width: 1000px }")}>
        <Modal
          closeHandler={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]);
          }}
          open={changeLogModalOpen}
          title="更新履歴"
          submitText="閉じる"
          onSubmit={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]);
          }}
          closeText=""
        >
          <ChangeLogModal changeLogData={changeLogData} isStamp={true}/>
        </Modal>
      </div>
      {/* ./Change log  */}
    </div>
  );
};

export default StampAccordion;
